import React from "react";

import cn from "classnames";

import { Box, boxForwardRef } from "../../../../../helpers";
import { useTextChildProps } from "../../../../../helpers/common/TextCore/helpers/useTextChildProps";
import { useTextCoreStore } from "../../../../../helpers/common/TextCore/store/store";
import { createDisplayNameForTextElement } from "../../utils/getDisplayName";
import { createTestIdForTextElement } from "../../utils/getTestId";

import type { BoxComponentWithDefault } from "../../../../../helpers";
import type { TextCoreChildProps } from "../../../../../helpers/common/TextCore/types";
import type {
    Optional,
    PropsWithCustomVarsStyles,
    PropsWithTsId,
} from "../../../../../types/react";

import classes from "./TextItem.styl";

export const TEXT_ITEM_TEST_ID = createTestIdForTextElement("item");

export type TextItemProps = Optional<
    PropsWithTsId<PropsWithCustomVarsStyles<TextCoreChildProps>>,
    "data-tsid"
>;

export type PolymorphicTextItemProps = BoxComponentWithDefault<
    "span",
    TextItemProps,
    "style" | "className"
>;

export const TextItem = boxForwardRef<PolymorphicTextItemProps>(
    ({
        as = "span",
        children,
        customVarsStyles,
        "data-tsid": tsid,
        ...props
    }) => {
        const { asList } = useTextCoreStore();

        const { className, style, filteredProps } = useTextChildProps(
            props,
            cn(classes["custom-vars"], customVarsStyles),
        );

        const asValue = asList && as === "span" ? "li" : as;

        return (
            <Box
                as={asValue}
                data-tsid={tsid || TEXT_ITEM_TEST_ID}
                className={className}
                style={style}
                tabIndex={-1}
                {...filteredProps}
            >
                {children}
            </Box>
        );
    },
);

TextItem.displayName = createDisplayNameForTextElement("Item");
export default TextItem;
